import React from 'react';
import store from '../store';
import { Route, Redirect } from 'react-router-dom';
import AppLayoutRoute from './AppLayoutRoute';
import { setIntendedUrl } from '../helpers/auth';
import PropTypes from 'prop-types';

const propTypes = {
  component: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.func
  ]).isRequired,
  rest: PropTypes.object,
  location: PropTypes.object
};

const AuthRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={props => {
      const { auth: { authenticated, user } } = store.getState();

      if (!authenticated) {
        setIntendedUrl(props.location.pathname);
      }

      // if (user) {
      //     if (!user.last_active_terms_accepted && props.location.pathname !== '/accept-terms')
      //         return <Redirect to="/accept-terms" />
      // } else {
      //     return <Redirect to="/" />;
      // }

      return authenticated ? (
        <AppLayoutRoute component={Component} {...props} />
      ) : (
        <Redirect
          to={{
            pathname: '/',
            state: { from: props.location }
          }}
        />
      );
    }
    }
  />
);

AuthRoute.propTypes = propTypes;
AuthRoute.displayName = 'Auth Route';

export default AuthRoute;
